/**
 * 安聆 SafeListen - 多端守护状态显示模块
 * 监测端：n台远程设备守护中 / 暂无远程设备守护
 * 接收端：已绑定监测端 - 守护中 / 监测端已断开连接 - 守护终止
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import './GuardStatus.css';

export default function GuardStatus({ isMonitor, receiverCount = 0, receiverBound, guardActive = false }) {
  const { t } = useTranslation();

  if (isMonitor) {
    const text =
      receiverCount > 0
        ? (guardActive ? t('guard.connectedMonitoring', { n: receiverCount }) : t('guard.connectedIdle', { n: receiverCount }))
        : t('guard.noDevices');
    return (
      <div className="safelisten-card guard-status monitor">
        <SafetyCertificateOutlined className="guard-icon" />
        <span className="safelisten-highlight">{text}</span>
      </div>
    );
  }

  const bound = !!receiverBound;
  const text = bound ? t('guard.bound') : t('guard.disconnected');
  return (
    <div className={`safelisten-card guard-status receiver ${bound ? 'bound' : 'disconnected'}`}>
      <span className={bound ? 'safelisten-highlight' : 'safelisten-warning-text'}>{text}</span>
    </div>
  );
}
